@if (url) {
  <div class="flex space-x-4 items-center">
    <button (click)="copy()" mat-icon-button [matTooltip]="'common.copyLink' | translate">
      <mat-icon>content_copy</mat-icon>
    </button>
    @if (webShareSupported) {
      <button (click)="share()" mat-icon-button [matTooltip]="'common.shareLink' | translate">
        <mat-icon>share</mat-icon>
      </button>
    }
  </div>
}
